<script setup lang="ts">
// Owned copy of shared-fe/components/ui/Button.vue, rewritten with scoped CSS (no Tailwind).
withDefaults(
  defineProps<{
    variant?: 'default' | 'outline' | 'ghost' | 'destructive'
    size?: 'sm' | 'md'
    type?: 'button' | 'submit' | 'reset'
    disabled?: boolean
    loading?: boolean
  }>(),
  { variant: 'default', size: 'md', type: 'button', disabled: false, loading: false },
)
</script>

<template>
  <button :type="type" :disabled="disabled || loading" :aria-busy="loading" :class="['btn', variant, size]">
    <span v-if="loading" class="spinner" aria-hidden="true" />
    <slot />
  </button>
</template>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  border-radius: var(--radius);
  font: inherit;
  font-weight: 500;
  font-size: 0.9rem;
  border: 1px solid transparent;
  cursor: pointer;
  transition: opacity 0.15s, background-color 0.15s;
}
.md {
  height: 2.5rem;
  padding: 0 1rem;
}
.sm {
  height: 2rem;
  padding: 0 0.75rem;
  font-size: 0.85rem;
}
.default {
  background: var(--accent);
  color: #fff;
}
.destructive {
  background: var(--loss);
  color: #fff;
}
.default:hover,
.destructive:hover {
  opacity: 0.9;
}
.outline {
  background: transparent;
  color: var(--fg);
  border-color: var(--flexoki-base-200);
}
.dark .outline {
  border-color: var(--border);
}
.ghost {
  background: transparent;
  color: var(--fg);
}
.outline:hover,
.ghost:hover {
  background: var(--bg-card);
}
.btn:disabled {
  opacity: 0.5;
  cursor: default;
}
.spinner {
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
